import * as Style from "./Card.style";

export default function Card({ children, size }) {
  return (
    <Style.CardContainer size={size ?? "300px"}>
      {children}
    </Style.CardContainer>
  );
}